export default (locale) => {
  return `https://help.reverb.com/hc/${locale}`;
};
